import React from 'react';
import Link from '../../../components/LocalizedLink';

const toitlustus = {
	'toitlustus.pealkiri': 'Toitlustus',
	'toitlustus.blokk1': () => (
		<>
			<h2 className='title is-2'>Puhkeküla köök</h2>
			<p>
				Pakume toitlustusteenust ettetellimisel majutujatele, gruppidele,
				suvepäevadeks, seminarideks, juubeliteks, pulmapidustusteks jne.
			</p>
			<p>Kõik meie maitsvad toidud valmivad kohapeal.</p>
			<p>Madalhooajal saame kokkuleppeliselt pakkuda cateringi teenust.</p>
			<p>Meilt saate tellida: </p>
			<div className='columns'>
				<div className='column is-6'>
					<ul>
						<li>pulmalaua</li>
						<li>peolaua</li>
						<li>sünnipäevalaua</li>
						<li>peielaua</li>
						<li>seminari kohvipausid</li>
					</ul>
				</div>
				<div className='column is-6'>
					<ul>
						<li>hommiku-, lõuna- ja õhtusöögid</li>
						<li>saunasnäkid</li>
						<li>piknikukorvi</li>
						<li>catering</li>
						<li>jne</li>
					</ul>
				</div>
			</div>
			<p>
				Toitlustame üksnes majutujaid ja hiljemalt eelneval päeval tellimuse
				teinud gruppe!
			</p>
			<p>
				Hommiku-, lõuna- või õhtusööki soovides palume kindlasti juba majutust
				broneerides sellest teada anda!
			</p>
			<p>
				Nädala sees algab õhtusöök suvehooajal tavapäraselt kell 19.00, hommiku-
				ja lõunasöögiaeg on kokkuleppel. Päevamenüü on kõikidel tellijatel sama,
				kuid arvestame ka erisoovidega.
			</p>
			<p>
				Madalhooajal me üksikuid majutujaid ei toitlusta, meil on pakkuda kenad{' '}
				<Link to='/majutus/ridaelamud'>korterid</Link> kus on kõik olemas
				toiduvalmistamiseks.
			</p>
		</>
	)
};

export default toitlustus;
